import { APICONSTANTS } from '../../constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { CycleBcModel } from '../../models/societe-linked/bc/cycle-bc.model';
import { SocieteLinkedService } from '../societe-linked/societe-linked.service';
import { HostnameService } from '../basic/hostname.service';
import { CycleValidationDTO } from '../../dtos/cycleValidationDTO';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CycleBcService extends SocieteLinkedService<CycleBcModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTECYCLEBC, hostnameService);
  }
  getAllFromBc(idBc: number): Observable<CycleBcModel[]> {
    return this.getAllbyId('getfromBc/', idBc);
  }

  getLastValideurs(idBc: number): Observable<CycleBcModel[]> {
    return this.getAllbyId('getLastValideurs/', idBc);
  }

  getAllValidationFromBC(idBc: number, idSociete: number, codeCa1: string) {
    return this.http.get<CycleValidationDTO[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllValidationFromBC?idBc=' + idBc + '&idSociete=' + idSociete + '&codeCa1=' + codeCa1)
    .pipe(catchError(err => this.requestCatchError(err, 'Cycles de validation')));
  }

}